import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface Props extends ChildProps {
  type?: BadgeType
  disabled?: boolean
  onClick?(e: React.MouseEvent<HTMLElement>): void
}

const SelectButton = ({ children, type = BadgeType.SUCCESS, disabled = false, onClick }: Props) => {
  return (
    <button
      type='button'
      className={clsx(
        'outline-default group inline-flex max-w-full items-center rounded-lg whitespace-nowrap focus:appearance-none disabled:pointer-events-none'
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {disabled ? (
        <div className='inline-flex w-3 min-w-12 items-center justify-center'>
          <Text size={12} lineHeight={150} color={TextColor.DISABLED}>
            ー
          </Text>
        </div>
      ) : (
        <Badge badgeType={type} remnant size={10}>
          {children}
        </Badge>
      )}
      <Icon
        type={IconType.DOWN}
        color={disabled ? IconColor.DISABLED : IconColor.EMPHASIS}
        hoverColor={IconColor.EMPHASIS_HOVER}
        activeColor={IconColor.EMPHASIS_ACTIVE}
      />
    </button>
  )
}

export default SelectButton
